package one.primehealth.app

import kotlinx.serialization.Serializable

@Serializable
enum class ScreenSource {
    Onboarding,
    Paywall,
}
